import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["darkBg", "value", "onChange", "options", "textSize", "size", "classes", "namespace"];
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import noop from "../utils/noop";
import styles from './SwitcherCanary.css';
var cx = classNames.bind(styles);
export var SwitcherCanary = /*#__PURE__*/forwardRef(function SwitcherCanary(_ref, ref) {
  var _ref$darkBg = _ref.darkBg,
      darkBg = _ref$darkBg === void 0 ? false : _ref$darkBg,
      _ref$value = _ref.value,
      propsValue = _ref$value === void 0 ? '' : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? defaultPropObject : _ref$options,
      textSize = _ref.textSize,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(propsValue),
      _useState2 = _slicedToArray(_useState, 2),
      activeValue = _useState2[0],
      setActiveValue = _useState2[1];

  var handleChange = useCallback(function (value) {
    setActiveValue(value);

    if (onChange) {
      onChange(value);
    }
  }, [onChange]);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'switcherCanary'),
      getTestId = _getMethodsForTestId.getTestId;

  useEffect(function () {
    setActiveValue(propsValue);
  }, [propsValue]);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, getTestId(), {
    ref: ref,
    className: cx('root', "size_".concat(size), {
      dark_bg: darkBg
    }, classes.root)
  }), options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement("button", _extends({}, getTestId(value, 'option'), {
      key: value,
      className: cx('button', _defineProperty({
        active: activeValue === value
      }, textSize, textSize), classes.button),
      onClick: function onClick() {
        return handleChange(value);
      },
      type: "button",
      disabled: disabled
    }), label);
  }));
});